import React from 'react'
import { makeStyles, createStyles, Box } from '@material-ui/core'
// import MobileDetect from 'mobile-detect'
import { useTranslation } from 'react-i18next'
import { useImageTranslation } from 'src/hooks'
import ZoomImage from 'src/components/ZoomImage'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      '& img': {
        display: 'block',
        width: '100%',
      },
    },
    mobile: {
      maxWidth: 375,
    },
    imgBox: {
      marginTop: 16,
    },
  }),
)

const PaymentTutorial = () => {
  const classes = useStyles()
  // const device_type = navigator.userAgent
  // const md = new MobileDetect(device_type)
  // let os = md.os()
  const { t } = useTranslation()
  const [tImage] = useImageTranslation()
  // console.log(os)
  // const isMobile = os === 'iOS' || os === 'AndroidOS'
  return (
    <Box className={classes.root} fontSize="body2.fontSize">
      <Box fontSize={32} fontWeight={600}>
        {t('glossary. use_discount_code')}
      </Box>
      <Box fontSize={18} fontWeight={600} ml={-2.5} mt={4}>
        <ul>
          <li> {t('glossary.promotion.step4')} </li>
        </ul>
      </Box>
      <Box fontSize={14} fontWeight={600} color="#4B5563" backgroundColor="none">
        <ZoomImage
          imageStyle={classes.imgBox}
          srcThumbnail={tImage('paymentTutorial_pc_top', 'webp')}
          src={tImage('paymentTutorial_pc_top', 'webp')}
          alt="mobile payment tutorial 1"
        />

        <Box mt={1.5} mb={4}>
          {t('glossary.promotion.step0')}
        </Box>
        <ZoomImage
          srcThumbnail={tImage('paymentTutorial_pc_middle', 'webp')}
          src={tImage('paymentTutorial_pc_middle', 'webp')}
          alt="mobile payment tutorial 1"
        />
        <ZoomImage
          imageStyle={classes.imgBox}
          srcThumbnail={tImage('paymentTutorial_pc_bottom', 'webp')}
          src={tImage('paymentTutorial_pc_bottom', 'webp')}
          alt="mobile payment tutorial 1"
        />

        <Box mt={1.5} mb={4}>
          {t('glossary.promotion.step6')}
        </Box>
      </Box>
    </Box>
  )
}

export default PaymentTutorial
